import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Globals } from './../../globals'

@Component({
  selector: 'app-head-back',
  templateUrl: './head-back.component.html'
})
export class HeadBackComponent implements OnInit{

  @Input()
  titulo: string;
  public titulolocal: string;
  todayDate: Date = new Date();

  globals: Globals

  constructor(globals: Globals) {
    this.globals = globals;
  }


  ngOnInit() {
    this.titulolocal = this.titulo;
  }
}
